/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react';
import DateInput from '../../global/DateInput';
import countryList from 'react-select-country-list';
import Dropdown from '../../../common/dropdown/Dropdown';
import { TInfo, TStep4Info } from '../../../types';
import { useVerifyBvnMutation } from '../../../features/businessRegistration/businessRegistrationSlice';
import { validateEmail } from '../../../lib/validateEmail';
import Button from '../../global/Button';
import './businessRegistration.css';
import Tippy from '@tippy.js/react';
import { getFromLocalStorage } from '../../../utils/setRegInfoInLocalStorage';
import { registerNetcoreActivity } from '../../../utils/registerActivity';
import ReactGA from 'react-ga4';
import { validateOwnersInput } from '../../../utils/validateOwnerInputs';
import { useAppSelector } from '../../../app/hooks';

type BusinessOwnerFormProps = {
  info: TStep4Info;
  setInfo: React.Dispatch<React.SetStateAction<TStep4Info>>;
  showingPartner: boolean;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setShowAddPartnersForm: React.Dispatch<React.SetStateAction<boolean>>;
  partners: TStep4Info[];
};

const BusinessOwnerFilledForm = ({
  info,
  setInfo,
  showingPartner,
  setStep,
  partners,
  setShowAddPartnersForm,
}: BusinessOwnerFormProps) => {
  const countries = useMemo(() => countryList().getData(), []);
  const [ownersInfo, setOwnersInfo] = useState(info);
  const [invalidOwnerState, setInvalidOwnerState] = useState(false);
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);
  const [showTippy, setShowTippy] = useState(false);

  const isfirstNameValid = ownersInfo?.firstName?.length > 0;
  const islastNameValid = ownersInfo?.lastName?.length > 0;

  const isBusinessEmailValid = validateEmail(ownersInfo?.businessEmail);
  const isOccupationValid = ownersInfo?.occupation?.length > 0;

  const [verify, { isLoading, isSuccess }] = useVerifyBvnMutation();

  const step1 = getFromLocalStorage('form1');

  const step1Info: TInfo = step1 && JSON.parse(step1);

  const form1 = localStorage.getItem('form1');

  const submitFn = () => {
    setInfo(ownersInfo);
    step1Info?.structureOfBusiness !== 'partnership'
      ? setStep((currPage: any) => currPage + 1)
      : setShowAddPartnersForm(true);
    registerNetcoreActivity(
      {
        emailAddress: details?.email,
        firstName: details?.firstName,
        lastName: details?.lastName,
        mobileNumber: details?.phoneNumber,
      },
      'TBH_BUSINESS_REGISTRATION_STEP_6',
    );
    ReactGA.event({
      category: 'formSubmit',
      action: 'TBH_BUSINESS_REGISTRATION_STEP_6',
      label: 'TBH_BUSINESS_REGISTRATION_STEP_6',
      // value: 1
    });
  };

  useEffect(() => {
    if (Object.keys(ownersInfo).length > 0 && !validateOwnersInput(ownersInfo)) {
      setInvalidOwnerState(true);
    } else if (partners.length > 0) {
      for (const obj of partners) {
        if (!validateOwnersInput(obj)) {
          setInvalidOwnerState(true);
          break;
        } else {
          setInvalidOwnerState(false);
        }
      }
    } else {
      setInvalidOwnerState(false);
    }
  }, [ownersInfo, partners]);

  return (
    <form className='w-full formCont stepFour'>
      <div className='w-full flex justify-center'>
        <div className='w-full'>
          <div className='personal-form'>
            <div className='mb-[27px]'>
              <label className='flex items-center ml-2 relative text-[#212121] '>
                <div className='flex flex-row'>
                  First name
                  <span className='text-[red] ml-2'>*</span>
                </div>

                {!isfirstNameValid && <div className='text-xs text-[red]'>Invalid first name</div>}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={ownersInfo?.firstName ?? ''}
                onChange={(e) => {
                  // const re = /^[A-Za-z]+$/;
                  // if (e.target.value === '' || re.test(e.target.value)) {
                  setOwnersInfo((prev) => ({
                    ...prev,
                    firstName: e.target.value.replace(/[0-9]/g, ''),
                  }));
                  // }
                }}
              />
            </div>
            <div className='mb-[27px]'>
              <label className='flex items-center ml-2 relative text-[#212121] '>
                <div className='flex flex-row'>
                  Last name
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {!islastNameValid && (
                  <div className='text-xs text-[red] ml-2'>Invalid last name</div>
                )}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={ownersInfo?.lastName ?? ''}
                onChange={(e) => {
                  // const re = /^[A-Za-z]+$/;
                  // if (e.target.value === '' || re.test(e.target.value)) {
                  setOwnersInfo((prev) => ({
                    ...prev,
                    lastName: e.target.value.replace(/[0-9]/g, ''),
                  }));
                  // }
                }}
              />
            </div>
            <div className='mb-[27px]'>
              <label className='flex items-center ml-2 relative text-[#212121] '>
                Other names
                {/* {!isOtherNameValid && (
                  <div className='text-xs text-[red] ml-2'>Invalid other names</div>
                )} */}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={ownersInfo?.otherName ?? ''}
                onChange={(e) => {
                  // const re = /^[A-Za-z]+$/;
                  // if (e.target.value === '' || re.test(e.target.value)) {
                  setOwnersInfo((prev) => ({
                    ...prev,
                    otherName: e.target.value.replace(/[0-9]/g, ''),
                  }));
                  // }
                }}
              />
            </div>
            <div className='mb-[27px]'>
              <label className='flex items-center ml-2 relative text-[#212121] '>
                Former name
                {/* {!isFormerNameValid && (
                  <div className='text-xs text-[red] ml-2'>Invalid former name</div>
                )} */}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={ownersInfo?.formername ?? ''}
                onChange={(e) => {
                  // const re = /^[A-Za-z]+$/;
                  // if (e.target.value === '' || re.test(e.target.value)) {
                  setOwnersInfo((prev) => ({
                    ...prev,
                    formername: e.target.value.replace(/[0-9]/g, ''),
                  }));
                  // }
                }}
              />
              {/* /> */}
            </div>
            <div className='w-full text-xs mb-[27px] '>
              <Dropdown
                className='border rounded-[4px] !h-[52px] !px-[10px] md:!px-[16px]'
                label='Nationality'
                placeholder={ownersInfo?.nationality ?? ''}
                required
                labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                options={countries.map((country) => {
                  return {
                    value: country.label,
                    label: country.label,
                    // name: country.value,
                  };
                })}
                width='100%'
                setSelectedOption={(e: { value: string; label: string }) => {
                  setOwnersInfo((prev) => ({ ...prev, nationality: e.value }));
                }}
              />
              {/* )} */}
              {/* /> */}
            </div>
            <div className='w-full text-xs mb-[27px] '>
              <Dropdown
                className='border rounded-[4px] !h-[52px] '
                label='Gender'
                required
                placeholder={ownersInfo?.gender ?? ''}
                labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                options={[
                  { value: 'Male', label: 'Male' },
                  { value: 'Female', label: 'Female' },
                ]}
                width='100%'
                setSelectedOption={(e: { value: string; label: string }) => {
                  setOwnersInfo((prev) => ({ ...prev, gender: e.value }));
                }}
              />
              {/* )}
                /> */}
            </div>
            <div className='mb-[27px]'>
              <label className='flex items-center ml-2 relative text-[#212121] '>
                <div className='flex flex-row'>
                  Business email address
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {!isBusinessEmailValid && (
                  <div className='text-xs text-[red] ml-2'>Invalid business email</div>
                )}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={ownersInfo?.businessEmail ?? ''}
                onChange={(e) => {
                  setOwnersInfo((prev) => ({
                    ...prev,
                    businessEmail: e.target.value?.toLowerCase(),
                  }));
                }}
              />
            </div>
            <div className='w-full text-xs mb-[27px] '>
              <Dropdown
                className='border rounded-[4px] !h-[52px] '
                label='Identity Type'
                required
                subLabel='The NIN ID card is the only valid ID card for this registration'
                placeholder={ownersInfo?.identityType ?? ''}
                labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                options={[
                  { value: 'National Identity Card', label: 'National Identity Card' },
                  // { value: "Voter's Card", label: "Voter's Card" },
                  // { value: 'Driver License', label: 'Driver License' },
                ]}
                width='100%'
                setSelectedOption={(e: { value: string; label: string }) => {
                  setOwnersInfo((prev) => ({ ...prev, identityType: e.value }));
                }}
              />
              {/* )}
                /> */}
            </div>
            <div className='mb-[27px]'>
              {/* <label className='flex items-center ml-2 relative text-[#212121] '>
                Identity number
                {!isIdentityNumberValid && (
                  <div className='text-xs text-[red] ml-2'>Invalid identity number</div>
                )}
              </label> */}
              <label className='flex flex-row relative text-[#212121] justify-between'>
                <div className='flex flex-row'>
                  Identity number
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {info?.identityNumber?.length > 0 && info?.identityNumber?.length !== 11 && (
                  <span className='text-[red]'>must be 11 digits</span>
                )}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={ownersInfo?.identityNumber ?? ''}
                onChange={(e) => {
                  setOwnersInfo((prev) => ({ ...prev, identityNumber: e.target.value }));
                }}
                maxLength={11}
              />
            </div>
            <div className='mb-[27px]'>
              <label className='flex items-center ml-2 relative text-[#212121] '>
                <div className='flex flex-row'>
                  Occupation
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {!isOccupationValid && (
                  <div className='text-xs text-[red] ml-2'>Invalid occupation</div>
                )}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={ownersInfo?.occupation ?? ''}
                onChange={(e) => {
                  // const re = /^[A-Za-z]+$/;
                  // if (e.target.value === '' || re.test(e.target.value)) {
                  setOwnersInfo((prev) => ({
                    ...prev,
                    occupation: e.target.value.replace(/[0-9]/g, ''),
                  }));
                  // }
                }}
              />
            </div>
          </div>
          <div className='bvn-form'>
            <div className='bvn-header mt-[40px] '>
              <h3 className='font-poppins font-bold text-base text-green'>Provide more Details</h3>
              <p className='text-[13px] font-poppins font-normal '>
                It will help us to create a current account for your business
              </p>
            </div>
            {/* <div className='my-[27px]'>
              <label className='flex flex-col relative text-[#212121] '>
                <div className='flex flex-row'>
                  Enter Bank Verification Number (BVN)
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {!isBvnValid && <div className='text-xs text-[color] ml-2'>Invalid bvn</div>}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={ownersInfo?.bvn ?? ''}
                // readOnly
                onChange={(e) => {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === '' || re.test(e.target.value)) {
                    setOwnersInfo((prev) => ({ ...prev, bvn: e.target.value }));
                  }
                }}
              />
            </div> */}
            <Tippy
              visible={showTippy}
              className='bg-[wheat] text-xs text-[black] w-[280px]'
              arrow={false}
              content={`Enter number with 0 at the beginning e.g 0816*******`}
            >
              <div className='my-[27px]'>
                <label className='flex flex-row justify-between relative text-[#212121] '>
                  <div className='flex flex-col'>
                    <div className='flex flex-row'>
                      Phone Number
                      <span className='text-[red] ml-2'>*</span>
                    </div>
                    <span className='text-[10px] text-[grey]'>
                      CAC only accepts Nigerian numbers
                    </span>
                  </div>

                  {info?.bvnPhone?.length === 11 && info?.bvnPhone?.split('')[0] !== '0' && (
                    <span className='text-[red]'>Number must start with a 0</span>
                  )}
                </label>
                <div className='flex'>
                  <div className='w-[62px] border h-[52px] border-[#F8B400] px-[15px] rounded-[4px]   flex justify-center items-center bg-white'>
                    {
                      // countryCode ? myCountryCodeObject[countryCode] :
                      `+234`
                    }
                  </div>
                  <input
                    className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                    value={ownersInfo?.bvnPhone ?? ''}
                    onChange={(e) => {
                      const re = /^[0-9\b]+$/;
                      if (e.target.value === '' || re.test(e.target.value)) {
                        setOwnersInfo((prev) => ({ ...prev, bvnPhone: e.target.value }));
                      }
                      setShowTippy(true);
                    }}
                  />
                </div>
              </div>
            </Tippy>
            {isLoading && (
              <div className='text-xs'>Please wait while we verify the bvn details</div>
            )}

            <div className='my-[27px] '>
              <DateInput
                className='!h-[52px]'
                placeholderText='Enter your birth date'
                value={ownersInfo?.birthDate}
                req
                // disable={!isSuccess}
                onChange={(e: any) => {
                  setOwnersInfo((prev) => ({ ...prev, birthDate: e._d }));
                }}
              />
            </div>

            {!showingPartner && (
              <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center md:mt-[105px]'>
                <Button
                  className='px-5 !py-[10px] text-[11px] !bg-[#768396] text-white border-[0px] rounded-none '
                  size='sm'
                  underline={false}
                  theme='secondary'
                  onClick={() => {
                    setStep((currPage: any) => currPage - 1);
                  }}
                >
                  PREVIOUS
                </Button>
                <Button
                  disabled={invalidOwnerState}
                  theme='primary'
                  className={[
                    step1Info?.structureOfBusiness !== 'partnership'
                      ? 'px-3 py-[10px] text-[11px] inline-block '
                      : '!bg-[#76839624] font-bold text-[10px] !text-green ',
                  ].join(' ')}
                  size='sm'
                  underline={false}
                  onClick={() => {
                    submitFn();
                  }}
                >
                  {step1Info?.structureOfBusiness === 'partnership'
                    ? 'Add new Partner'
                    : `SAVE AND CONTINUE`}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default BusinessOwnerFilledForm;
